module.exports = __webpack_public_path__ + "img/circles-svg.048f6187.svg";